import styled from 'styled-components';

import colors from 'themes/Main';

const { gray01, darkBlue } = colors;

export const Item = styled.p`
  color: ${gray01};
  font-size: 16px;
  margin-bottom: 16px;

  span {
    display: inline-block;
    margin-right: 8px;
    color: ${darkBlue};
    font-weight: 700;
  }
`;

export const Form = styled.form`
  margin-top: 32px;
`;

export const Errors = styled.div`
  margin: 16px 0 -16px;

  span {
    margin-bottom: 4px;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 50px;

  button:first-child {
    margin-right: 16px;
  }
`;
